import TxpOption from 'owa-txp-option/lib/TxpOption';
import loadCalendarMailboxConfiguration from './loadCalendarMailboxConfiguration';
/**
 * Automatic processing subcategory settings
 */
var eventsFromEmailSubCategory = {
    key: 'calendarInEmail',
    titleStringKey: 'optionTitle_eventsForEmail',
    options: [TxpOption],
    onSelected: loadCalendarMailboxConfiguration,
};
export default eventsFromEmailSubCategory;
//# sourceMappingURL=eventsFromEmailSubCategory.js.map